import { ATTENDANTS_ROUTE, RESOURCES_ROUTE } from './CommandsApiRoutes';
import UpdateContactHubspot from './ContactStatusHubspot';

const IgnoreCommandsRequest = [
    ATTENDANTS_ROUTE,
    `${RESOURCES_ROUTE}/${UpdateContactHubspot.ProPlanRequestedKey}`
] as string[];

export default IgnoreCommandsRequest;